export const APPS_LOAD_REQUEST = 'APPS_LOAD_REQUEST'
export const APPS_LOAD_SUCCESS = 'APPS_LOAD_SUCCESS'

export const appsLoadRequest = () => ({ type: APPS_LOAD_REQUEST })
export const appsLoadSuccess = (apps) => ({ type: APPS_LOAD_SUCCESS, payload: { apps } })
